import { render, staticRenderFns } from "./TimeProgress.vue?vue&type=template&id=39f975d6&scoped=true&"
import script from "./TimeProgress.vue?vue&type=script&lang=js&"
export * from "./TimeProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-internal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f975d6",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BProgress} from 'bootstrap-vue'
    installComponents(component, {BProgress})
    

export default component.exports